module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "chatZoneLink",
    attrs: {
      "href": "javascript:alert(this);",
      "to": _vm.item.routeLink,
      "rel": _vm.item.rel
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_c('div', {
    staticClass: "chatZoneMenuItemTitle"
  }, [_c('p', {
    staticClass: "channel-title"
  }, [_vm._v(_vm._s(_vm.item.zoneName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.userCount > 0 ? _vm.item.userCount.toLocaleString() : ""))]), _vm._v(" "), _c('p', {
    staticClass: "active-bar"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5f7a7e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-zone-menu-item.vue
// module id = 109
// module chunks = 0